import { useTranslation } from 'react-i18next';
import { S, Icon } from '../regureStyles';
import { docTypeLabel } from '../../utils/docTypeLabels';

const Filter = ({ search, setSearch, filterType, setFilterType, docTypes, filtered }) => {
  const { t, i18n } = useTranslation();
  const lang = (i18n?.language || 'en').split('-')[0];
  return (
    <div style={{ display: 'flex', gap: 12, marginBottom: 20, alignItems: 'center', flexWrap: 'wrap' }}>
      <div style={{ position: 'relative', flex: 1, minWidth: 240, maxWidth: 380 }}>
        <div style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)' }}>
          <Icon name='search' color='#94a3b8' size={15} />
        </div>
        <input
          value={search}
          onChange={e => setSearch(e.target.value)}
          placeholder={t('screens.unmatchedDocs.filter.searchPlaceholder')}
          style={{
            width: '100%',
            padding: '9px 12px 9px 36px',
            border: `1px solid ${S.borderLight}`,
            borderRadius: 8,
            fontSize: 13,
            color: S.textPrimary,
            outline: 'none',
            boxSizing: 'border-box',
          }}
        />
      </div>
      <select
        value={filterType}
        onChange={e => setFilterType(e.target.value)}
        style={{ padding: '8px 12px', border: `1px solid ${S.borderLight}`, borderRadius: 8, fontSize: 13, color: S.textPrimary, outline: 'none', cursor: 'pointer' }}
      >
        {docTypes.map(dt => (
          <option key={dt} value={dt}>
            {dt === 'All' ? t('screens.unmatchedDocs.filter.all') : docTypeLabel(dt, lang)}
          </option>
        ))}
      </select>
      <span style={{ fontSize: 12, color: S.textMuted, marginLeft: 'auto' }}>{t('screens.unmatchedDocs.filter.documentCount', { count: filtered.length })}</span>
    </div>
  );
};

export default Filter;
